import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import SEO from "@/components/SEO";

export default function NotFound() {
  return (
    <section className="relative min-h-screen bg-gradient-to-br from-navy via-navy-800 to-navy-900 flex items-center overflow-hidden" data-testid="not-found-page">
      <SEO title="Page Not Found" description="The page you requested could not be found." path="/404" />
      <div className="absolute inset-0 grid-pattern-dark" aria-hidden="true" />
      <div className="container-site relative py-32 text-center">
        <p className="font-mono text-sm uppercase tracking-[0.3em] text-teal">Error 404</p>
        <h1 className="mt-5 font-heading text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-white">
          Page Not Found
        </h1>
        <p className="mt-5 text-base sm:text-lg text-slate-300 max-w-md mx-auto">
          The page you are looking for does not exist or may have been moved.
        </p>
        <Link
          to="/"
          data-testid="not-found-home-btn"
          className="mt-9 inline-flex items-center gap-2 bg-teal hover:bg-teal-dark text-white font-semibold px-7 py-3.5 rounded-full transition-colors duration-200"
        >
          <ArrowLeft size={16} aria-hidden="true" />
          Back to Home
        </Link>
      </div>
    </section>
  );
}
